export default "__VITE_ASSET__AV$vjb4D__"